export default __webpack_public_path__ + "static/media/Minicard_As.4105fc25.svg";